import { debounce } from "../../shared/js/debounce";
import { superToggle } from "./helpers/super-toggle";

window.addEventListener('load', () => {

    // Dropdown Test
    let offCanvasMenuTest = document.getElementById('offCanvasMenuTest');
    let menuToggleDropdown = document.getElementById('menuToggleDropdown');

    let offCanvasMenuTest2 = document.getElementById('offCanvasMenuTest2');
    let menuToggleDropdown2 = document.getElementById('menuToggleDropdown2');

    let offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    let menuToggleMobile = document.getElementById('menuToggleMobile');

    let menuBackdrop = document.getElementById('headerNavigationBackdrop');

    let desktopHeaderLogo = document.getElementById('desktopHeaderArtrageLogo');

    let scrollLimit = 500;

    if (offCanvasMenuTest && menuToggleDropdown) {
        // measures to stop menu appearing on page load
        offCanvasMenuTest.removeAttribute('style');

        menuToggleDropdown.addEventListener('click', () => {
            offCanvasMenuTest.classList.toggle('-translate-y-full');
            menuToggleDropdown.classList.toggle('active');
            scrollLimit = (offCanvasMenuTest.offsetHeight / 3) * 2;

            if (menuToggleDropdown.querySelector('svg')) {
                menuToggleDropdown.querySelector('svg').classList.toggle('rotate-180');
            }

            if (offCanvasMenuTest2 && menuToggleDropdown2) {
                offCanvasMenuTest2.classList.add('-translate-y-full');
                menuToggleDropdown2.classList.remove('active');

                if (menuToggleDropdown2.querySelector('svg')){
                    menuToggleDropdown2.querySelector('svg').classList.remove('rotate-180');
                }

                if (menuToggleDropdown2.classList.contains('active') || menuToggleDropdown.classList.contains('active') ) {
                    menuBackdrop.classList.remove('opacity-0');
                    desktopHeaderLogo.classList.add('lg:!opacity-100')

                } else {
                    menuBackdrop.classList.add('opacity-0');
                    desktopHeaderLogo.classList.remove('lg:!opacity-100')
                }
            }

            startListening();
        });
    }

    if (offCanvasMenuTest2 && menuToggleDropdown2) {
        // measures to stop menu appearing on page load
        offCanvasMenuTest2.removeAttribute('style');

        menuToggleDropdown2.addEventListener('click', () => {
            offCanvasMenuTest2.classList.toggle('-translate-y-full');
            menuToggleDropdown2.classList.toggle('active');
            menuToggleDropdown2.querySelector('svg').classList.toggle('rotate-180');
            menuBackdrop.classList.toggle('opacity-0');
            scrollLimit = (offCanvasMenuTest2.offsetHeight / 3) * 2;

            if (offCanvasMenuTest && menuToggleDropdown) {
                offCanvasMenuTest.classList.add('-translate-y-full');
                menuToggleDropdown.classList.remove('active');
                menuToggleDropdown.querySelector('svg').classList.remove('rotate-180');

                if (menuToggleDropdown.classList.contains('active') || menuToggleDropdown2.classList.contains('active') ) {
                    menuBackdrop.classList.remove('opacity-0');
                    desktopHeaderLogo.classList.add('lg:!opacity-100')
                } else {
                    menuBackdrop.classList.add('opacity-0');
                    desktopHeaderLogo.classList.remove('lg:!opacity-100')
                }
            }

            startListening();
        });
    }

    let hamburgerTop1 = menuToggleMobile.querySelector('.hamburger-top-1');
    let hamburgerTop2 = menuToggleMobile.querySelector('.hamburger-top-2');
    let hamburgerMid = menuToggleMobile.querySelector('.hamburger-mid');
    let hamburgerBot = menuToggleMobile.querySelector('.hamburger-bot');

    if (offCanvasMenuMobile && menuToggleMobile) {
        // measures to stop menu appearing on page load
        offCanvasMenuMobile.removeAttribute('style');

        menuToggleMobile.addEventListener('click', () => {
            offCanvasMenuMobile.classList.toggle('-translate-y-full');
            menuToggleMobile.classList.toggle('active');
            if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot ){
                superToggle(hamburgerTop1, ['!top-1/2', 'rotate-45']);
                superToggle(hamburgerTop2, ['!top-1/2', '-rotate-45']);
                superToggle(hamburgerMid, ['opacity-0', '!w-0']);
                superToggle(hamburgerBot, ['opacity-0', '!w-0', '!-translate-y-2']);
            }
            menuBackdrop.classList.toggle('opacity-0');
            scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
            startListening();
        });
    }

    function closeMobileNav() {
        if (!offCanvasMenuMobile.classList.contains('-translate-y-full')) {
            offCanvasMenuMobile.classList.add('-translate-y-full');
            if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot ) {
                hamburgerTop1.classList.remove('!top-1/2');
                hamburgerTop1.classList.remove('rotate-45');
                hamburgerTop2.classList.remove('!top-1/2');
                hamburgerTop2.classList.remove('-rotate-45');
                hamburgerMid.classList.remove('opacity-0');
                hamburgerMid.classList.remove('!w-0');
                hamburgerBot.classList.remove('opacity-0');
                hamburgerBot.classList.remove('!w-0');
                hamburgerBot.classList.remove('!-translate-y-2');
            }
        }
        if (!menuBackdrop.classList.contains('opacity-0')) {
            menuBackdrop.classList.add('opacity-0');
        }
    }

    function closeDesktopNav() {
        if (!offCanvasMenuTest.classList.contains('-translate-y-full') || !offCanvasMenuTest2.classList.contains('-translate-y-full')) {
            offCanvasMenuTest.classList.add('-translate-y-full');
            offCanvasMenuTest2.classList.add('-translate-y-full');
            menuToggleDropdown.querySelector('svg').classList.remove('rotate-180');
            menuToggleDropdown.classList.remove('active');
            menuToggleDropdown2.querySelector('svg').classList.remove('rotate-180');
            menuToggleDropdown2.classList.remove('active');
        }
        if (!menuBackdrop.classList.contains('opacity-0')) {
            menuBackdrop.classList.add('opacity-0');
        }

        desktopHeaderLogo.classList.remove('lg:!opacity-100')
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
        closeDesktopNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }


    // Debounce for resize listener to close open menus on page resize
    const closeNavResizeDebouncer = debounce(() => {
        let windowSize = window.innerWidth;
        const checkWidth = setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
            clearTimeout(checkWidth);
        }, 50);

    });

    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebouncer = debounce((event) => {
        if (!document.getElementById('headerNavigationMenu').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    });

    // Debounce for scroll listener to close open menus if scroll 200px or more below top of page
    const closeNavScrollDebouncer = debounce(() => {
        if (window.scrollY >= scrollLimit && (!menuBackdrop.classList.contains('opacity-0'))) {
            closeAllNavs();
            stopListening();
        }
    });

    const clickListener = () => {
        closeNavClickDebouncer(event);
    };

    const resizeListener = () => {
        closeNavResizeDebouncer();
    };

    const scrollListener = () => {
        closeNavScrollDebouncer();
    };
});
